<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <div>
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary">
        Ondersteuning bij maatregel 29
      </h1>

      <div class="d-flex flex-column flex-lg-row justify-content-center">
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">
            <!-- <base-card class="mb-4" inner-class="small" color="secondary">
              <h6 class="mb-2">Wilt u ondersteuning?</h6>
              <checkmark-item icon="info-circle-fill">
                Als u ondersteuning wilt bij de isolatieaanpak, nemen we contact met u op om de volgende stap samen te bespreken.
              </checkmark-item>
            </base-card> -->

            <base-input
              type="radiobuttons"
              :options="yesNoOptions"
              name="Maatregel29Support"
              v-model:value="lead.advice.Maatregel29Support"
            >
              Wilt u ondersteuning bij maatregel 29 de isolatieaanpak?
            </base-input>
            <issue-feedback :issue="qualStore.global.rules.Maatregel29Support" />
          </base-form>
        </base-card>
      </div>

      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.advice.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
  import BaseCard from "@/components/BaseCard.vue";
  import BaseForm from "@/components/BaseForm.vue";
  import BaseInput from "@/components/BaseInput.vue";
  import BaseButton from "@/components/BaseButton.vue";
  import ButtonRow from "@/components/ButtonRow.vue";
  import IssueFeedback from "@/components/IssueFeedback.vue";
  // import CheckmarkItem from "@/components/CheckmarkItem.vue";
  import { FlowService } from "@/services/FlowService";
  import { useAllStores } from "@/helpers/UseAllStores";

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      IssueFeedback,
      // CheckmarkItem,
    },
    setup() {
      return { ...useAllStores() };
    },
    data() {
      return {
        yesNoOptions: [
          { label: 'Ja', value: true },
          { label: 'Nee', value: false },
        ],
      };
    },
    mounted() {
      this.lead.markViewAsVisited(this.$route.name);
    },
    methods: {
      touchAndValidate() {
        this.v$.advice.$touch();
        return !this.v$.advice.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      },
    },
    watch: {
      'lead.advice.Maatregel29Support'(value) {
        this.lead.advice.HelpWithVHF = value;
      },
    },
  };
</script>
